import React, { useEffect, useState } from "react";
import $ from 'jquery';
import moment from "moment";


const ClaimDetail = (props) => {

    const [claimDetail, setClaimDetail] = useState(null)

    var today = moment().format('DD/MM/YYYY')

    useEffect(() => {
        if (props.isDisplayClaimDetail === true) {
            setClaimDetail(props.claimDetailObj)
            $("#app-body").addClass("modal-open");
            $("#app-body").append('<div class="modal-backdrop fade show"></div>');
        }
        else {
            $("#app-body").removeClass("modal-open");
            $(".modal-backdrop").remove();
        }

    }, [props.isDisplayClaimDetail, props.claimDetailObj])

    return (
        <>
            <div
                className="modal fade show"
                id="detailViewModal"
                tabIndex={-1}
                aria-labelledby="detailViewModalLabel"
                aria-hidden="true"
                style={{ display: props.isDisplayClaimDetail === true ? 'block' : 'none' }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="mt-2">Please review claim detail before submit</h6>
                            <button
                                type="button"
                                className="btn"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    $("#app-body").removeClass("modal-open");
                                    $(".modal-backdrop").remove();
                                    props.isClaimDetailClose({ data: false })
                                }}
                            >
                                <i className="fa fa-close" />

                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className="row  pt-2 mt-1" style={{ marginBottom: 16 }}>
                                <div className="col-12 col-md-4 mt-2">
                                    <label className="card-label">Policy Type :</label>
                                    <p className="card-value mb-0">{claimDetail?.policy_type_name}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Intimation Date :</label>
                                    <p className="card-value mb-0">{today}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Date of Loss</label>
                                    <p className="card-value mb-0">{moment(claimDetail?.date_of_loss, 'DD-MM-YYYY').format('DD/MM/YYYY')}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Insurer</label>
                                    <p className="card-value mb-0">{claimDetail?.nameOfInsured}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Nature of Claim</label>
                                    <p className="card-value mb-0"> {claimDetail?.nature_of_claim}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">RM Name</label>
                                    <p className="card-value mb-0">{claimDetail?.rm_name}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Claim Description</label>
                                    <p className="card-value mb-0">{claimDetail?.loss_details}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Loss Location</label>
                                    <p className="card-value mb-0">{claimDetail?.loss_location}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Claim Type</label>
                                    <p className="card-value mb-0">{claimDetail?.claim_type}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Estimate Loss Amount</label>
                                    <p className="card-value mb-0">{claimDetail?.amount}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Loss Site Contact Person Name</label>
                                    <p className="card-value mb-0">{claimDetail?.contact_person_name}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Loss Site Contact Person Mobile Number</label>
                                    <p className="card-value mb-0">{claimDetail?.contact_person_mobile_number}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Alternate Contact Person Name</label>
                                    <p className="card-value mb-0">{claimDetail?.alternate_contact_person_name}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Alternate Contact Person Number </label>
                                    <p className="card-value mb-0">{claimDetail?.alternate_contact_person_mobile_number}</p>
                                </div>
                                <div className="col-6 col-md-4 mt-2">
                                    <label className="card-label">Alternate Contact Person Email </label>
                                    <p className="card-value mb-0">{claimDetail?.alternate_contact_person_email}</p>
                                </div>
                            </div>
                            <button
                                type="button mt-3"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    props.isClaimDetailClose({ data: true })
                                }}
                            >
                                Submit
                            </button>
                            <button
                                type="button mt-3"
                                className="btn btn-secondary"
                                onClick={() => {
                                    $("#app-body").removeClass("modal-open");
                                    $(".modal-backdrop").remove();
                                    props.isClaimDetailClose({ data: false })
                                }}
                                style={{ marginLeft: 8, }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ClaimDetail;